import { observer } from '../../../../ImageBundle/public/js/image-resize';

const selImagesLazy = '.lazy-resize';

document.addEventListener('DOMContentLoaded', () => {
    const loadViewPane = async (pane) => {
        if (!pane || pane.dataset.viewLoaded === '1' || pane.dataset.viewLoading === '1') {
            return;
        }

        const url = pane.dataset.viewLazyUrl;
        if (!url) {
            return;
        }

        pane.dataset.viewLoading = '1';

        try {
            const response = await fetch(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (!response.ok) {
                return;
            }

            pane.innerHTML = await response.text();
            pane.dataset.viewLoaded = '1';
    
            window.dispatchEvent(
                new CustomEvent( 'HTMLLazyLoaded', { detail: { element: pane } } )
            );
        } finally {
            pane.dataset.viewLoading = '0';
        }
    };

    const handleViewTrigger = (trigger) => {
        if (!trigger) {
            return;
        }

        const targetSelector = trigger.getAttribute('data-bs-target');
        if (!targetSelector) {
            return;
        }

        const pane = document.querySelector(targetSelector);
        loadViewPane(pane);
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-product-view-mode][data-bs-target]');
        if (!trigger) {
            return;
        }

        handleViewTrigger(trigger);
    });

    document.addEventListener('shown.bs.tab', (event) => {
        handleViewTrigger(event.target);
    });
});

document.addEventListener('DOMContentLoaded', () => {
});